(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular
    .module('app')
    .component('confirmBookingItemNotificationProvider', confirmBookingItemNotificationProvider());

  function confirmBookingItemNotificationProvider() {
    return {
      bindings: {
        notification: '<',
        bookingItem: '<',
        bookingItemServiceItem: '<',
        bookingCurrency: '<',
        subdomain: '<',
        companyApiKey: '<',
        onBookingItemNotificationConfirmed: '&',
      },
      controller: ConfirmBookingItemNotificationProviderComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/booking-item-notification-provider/' +
        'confirm-notification/confirm-booking-item-notification-provider.component.html',
    };
  }

  ConfirmBookingItemNotificationProviderComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'BookingItemNotificationProviderService',
  ];

  function ConfirmBookingItemNotificationProviderComponent(
    config,
    UtilService,
    moment,
    BookingItemNotificationProviderService
  ) {
    let vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.totalCostEditable = false;

    // Methods
    vm.editNetCost = editNetCost;
    vm.selectRequestPayment = selectRequestPayment;
    vm.openPaymentDatePicker = openPaymentDatePicker;
    vm.confirmBookingNotification = confirmBookingNotification;

    vm.$onInit = function () {
      let totalCost = !vm.bookingItemServiceItem
        ? vm.bookingItem.total_cost
        : vm.bookingItemServiceItem.total_cost;

      vm.notification.confirmed_by = '';
      vm.notification.confirmation_number = '';
      vm.notification.payment_net_cost = vm.notification.payment_net_cost || totalCost; // vm.UtilService.roundNum(
      vm.notification.payment_required = false;
      vm.notification.payment_percentage = 0;
      vm.notification.payment_date_limit = '';

      vm.originalPaymentNetCost = angular.copy(vm.notification.payment_net_cost);

      setPaymentDatePicker();
    };

    function setPaymentDatePicker() {
      vm.paymentDateOptions = {
        singleDatePicker: true,
        minDate: moment(),
        maxDate: moment(vm.bookingItem.start_date),
        drops: 'up',
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'hide.daterangepicker': function () {
            // Clear invalid input
            if (
              vm.notification.payment_date_limit &&
              !vm.notification.payment_date_limit._isValid
            ) {
              vm.notification.payment_date_limit = '';
              vm.paymentDateOptions.minDate = moment();
            }
          },
        },
      };
    }

    function openPaymentDatePicker() {
      document.querySelector<HTMLElement>('input[name="payment_date_limit"]').focus(); // Not working if modal opens more than once
    }

    function editNetCost() {
      if (!vm.totalCostEditable) {
        vm.notification.payment_net_cost = vm.originalPaymentNetCost;
      }
    }

    function selectRequestPayment() {
      vm.notification.payment_percentage = 100;

      if (!vm.notification.payment_required) {
        vm.notification.payment_percentage = 0;
        vm.notification.payment_date_limit = '';
      }
    }

    function confirmBookingNotification(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      if (vm.notification.payment_required) {
        vm.notification.payment_date_limit = vm.notification.payment_date_limit.format();
      }

      vm.notification.status = 'confirmed';

      let file = { file: vm.myFile };

      let params = {
        notificationUrl: null,
        obj: null,
      };

      // Booking item != Booking it service item
      if (!vm.bookingItemServiceItem) {
        params.notificationUrl = 'booking_item_notifications_provider';
        params.obj = { booking_item_notification: vm.notification };
      } else {
        params.notificationUrl = 'booking_item_service_item_notifications_provider';
        params.obj = { booking_item_service_item_notification: vm.notification };
      }

      vm.sendingForm = true;
      BookingItemNotificationProviderService.saveBookingItemNotificationProvider(
        vm.notification,
        vm.subdomain,
        vm.companyApiKey,
        params,
        file
      ).then(function (response) {
        let data = {
          status: response.data.status,
        };

        vm.onBookingItemNotificationConfirmed({ dataObj: data });

        vm.sendingForm = false;
      });
    }
  }
})();
